import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import ClaimForm from "Components/Form/ClaimForm";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import { addClaimValidation } from "core/Operations/ValidationSchema/claimValidationSchema";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import ShiftPolicyForm from "Components/Form/ShiftPolicyForm";
import { useInsertShiftPolicyMutation } from "AppQuries/shift/policy/shift-policy";
import { shiftPolicyValidation } from "core/Operations/ValidationSchema/shiftValidation";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
const AddShiftPolicy = () => {
  const userData = useSelector(loggedInUser);
  const {
    mutate: addShiftPolicy,
    isPending,
    isError,
    error,
  } = useInsertShiftPolicyMutation();

  const methods = useForm({
    defaultValues: {
      companyCode: userData?.companyCode,
      locationCode: userData?.locationCode,
      shiftPolicyID: 0,
      shiftType: "",
      isPremiumOT: false,
      otStartTime: "",
      otEndTime: "",
      shiftTypeID: "",
      otMinimumHours: "",
      otRoundOffMinimum: "",
    },
    resolver: yupResolver(shiftPolicyValidation),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;
  console.log(errors);
  const onSubmit = (payload) => {
    const requestData = [{ ...payload }];

    addShiftPolicy(requestData, {
      onSuccess: (data) => {
        console.log(data);
        if (data === true) {
          toast.success("Shift Policy Added Successfully.");

          // setTimeout(() => {
          navigate(`${all_routes.shift}${all_routes.shift_policy}`);
          // }, 1000);
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };
  if (isError) return <Error404 error={error} />;
  return (
    <div className="page-wrapper">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <h4>Add Shift Policy</h4>
                  <h6>Add your new Shift Policy </h6>
                </div>
              </div>
              
              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Save Shift Policy</Tooltip>
                  }
                >
                  <button type="submit" className="btn btn-added">
                    <Save className="me-2" />
                    Save
                  </button>
                </OverlayTrigger>
              </div>
              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                >
                  <Link
                    to={`${all_routes.shift}${all_routes.shift_policy}`}
                    className="btn btn-secondary"
                  >
                    <BackIcon className="me-2" />
                    Back
                  </Link>
                </OverlayTrigger>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card border-0">
                  <div className="card-header">
                    <h4 className="card-title">Add Shift Policy</h4>
                  </div>
                  <div className="card-body">
                    <ShiftPolicyForm />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default AddShiftPolicy;
